// Translations for the Branches page (Branches.js) - "Matawi" theming.
// NOTE: most of this page's JSX literals are authored in Swahili, so the
// `sw` field below must match those literals EXACTLY (that's the lookup
// key); `en` holds the English translation.
const branchesDict = [
  { en: "Failed to save branch", sw: "Imeshindwa kuhifadhi tawi" },
  { en: "Are you sure you want to delete this branch?", sw: "Je, una uhakika unataka kufuta tawi hili?" },
  { en: "Failed to delete branch", sw: "Imeshindwa kufuta tawi" },
  { en: "Manage the union's branches", sw: "Dhibiti matawi ya chama (branches)" },
  { en: "Add Branch", sw: "Ongeza Tawi" },
  { en: "Import CSV", sw: "Ingiza CSV" },
  { en: "No branches found", sw: "Hakuna matawi yaliyopo" },
  { en: 'Add a new branch by clicking "Add Branch".', sw: 'Ongeza tawi jipya kwa kubonyeza "Ongeza Tawi".' },
  { en: "Edit Branch", sw: "Hariri Tawi" },
  { en: "Branch Name *", sw: "Jina la Tawi *" },
  { en: "Region / Area", sw: "Mkoa / Eneo" },
  { en: "District", sw: "Wilaya" },
  { en: "Parent (Higher Branch)", sw: "Mzazi (Tawi la Juu)" },
  { en: "— None —", sw: "— Hakuna —" },
  { en: "Active", sw: "Inatumika" },
  { en: "Inactive", sw: "Haitumiki" },
  { en: "Import Branches (CSV)", sw: "Import Matawi (CSV)" },
  { en: "You can download a sample CSV", sw: "Unaweza kupakua mfano wa CSV" },
  { en: "here", sw: "hapa" },
  { en: "Created:", sw: "Imeundwa:" },
  { en: "Skipped:", sw: "Imerukwa:" },
  { en: "Errors:", sw: "Makosa:" },
  { en: "Errors", sw: "Makosa" },
  { en: "Row", sw: "Mstari" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Please select a CSV file", sw: "Tafadhali chagua faili la CSV" },
  { en: "Import failed", sw: "Uingizaji umeshindwa" },
  { en: "Upload", sw: "Pakia" },
];

export default branchesDict;
